/* eslint-env jquery */
export default function _studySearch() {
    const studySearch = document.querySelector(
        'input.study-search__form__query'
    );
    const studySearchBtn = document.querySelector(
        '.study-search__form__submit'
    );
    const baseFBUrl = 'https://search.otago.ac.nz/s/search.html';
    const collection = 'uoot-prod~sp-course-search';
    const profile = 'subs-and-quals-search_preview'; // remove '_preview' once course search is live
    const subjectsFacet = 'f.Tabs%7Cuoot-prod%7Eds-otago-subjects=Subjects';
    const qualificationsFacet =
        'f.Tabs%7Cuoot-prod%7Eds-otago-qualifications=Qualifications';
    const papersFacet =
        'f.Tabs%7Cuoot-prod%7Eds-otago-papers%2Cuoot-prod%7Eds-university-of-otago-papers=Course+Papers';

    // Conditionally check when autocomplete is activated to update styling
    const checkState = () => {
        const ttMenu = document.querySelector('.tt-menu');
        const ttDataset = document.querySelectorAll('.tt-dataset');
        let hasData = false;

        ttDataset.forEach((el) => {
            if (el.childNodes.length > 0) {
                hasData = true;
            } else {
                hasData = false;
            }
        });

        if (ttMenu.classList.contains('tt-open')) {
            if (hasData) {
                studySearch.classList.add('active');
                studySearchBtn.classList.add('active');

                ttMenu.style.display = 'grid';
            } else {
                studySearch.classList.remove('active');
                studySearchBtn.classList.remove('active');

                ttMenu.style.display = 'none';
            }
        } else {
            studySearch.classList.remove('active');
            studySearchBtn.classList.remove('active');

            ttMenu.style.display = 'none';
        }
    };

    if (studySearch) {
        // Standard Funnelback concierge autocomplete typeahead structure
        $(studySearch).autocompletion({
            datasets: {
                subjects: {
                    collection: 'uoot-prod~sp-course-search',
                    profile: 'subjects',
                    program:
                        'https://dxp-au-search.funnelback.squiz.cloud/s/suggest.json',
                    name: 'Subjects',
                    show: 5,
                    template: {
                        header: '<h5 class="tt-category">Subjects</h5>',
                        suggestion: (data) => {
                            const title = data.label.title.split(',')[0];
                            const url = data.label.liveUrl;
                            const queryUrl = `${baseFBUrl}?query=${title}&collection=${collection}&${subjectsFacet}&profile=${profile}`;

                            console.log(data);

                            return `<div><a href="${
                                url || queryUrl
                            }">${title}</a></div>`;
                        },
                        notFound:
                            '<div class="empty-message"><small><em>No suggestions match the current query</em></small></div>',
                        footer: `<div class="more-results">
                            <a href="${baseFBUrl}?query={{query}}*&collection=${collection}&${subjectsFacet}&profile=${profile}" class="study-search__all-results">Search all subjects<i class="fas fa-chevron-right" aria-hidden="true"></i></a>
                        <div>`,
                    },
                },
                qualifications: {
                    collection: 'uoot-prod~sp-course-search',
                    profile: 'qualifications',
                    program:
                        'https://dxp-au-search.funnelback.squiz.cloud/s/suggest.json',
                    name: 'Qualifications',
                    show: 5,
                    template: {
                        header: '<h5 class="tt-category">Qualifications</h5>',
                        suggestion: (data) => {
                            const title = data.label.title.split(',')[0];
                            const url = data.label.liveUrl;
                            const queryUrl = `${baseFBUrl}?query=${title}&collection=${collection}&${qualificationsFacet}&profile=${profile}`;

                            return `<div><a href="${
                                url || queryUrl
                            }">${title}</a></div>`;
                        },
                        notFound:
                            '<div class="empty-message"><small><em>No suggestions match the current query</em></small></div>',
                        footer: `<div class="more-results">
                            <a href="${baseFBUrl}?query={{query}}*&collection=${collection}&${qualificationsFacet}&profile=${profile}" class="study-search__all-results">Search all qualifications<i class="fas fa-chevron-right" aria-hidden="true"></i></a>
                        <div>`,
                    },
                },
                papers: {
                    collection: 'uoot-prod~sp-course-search',
                    profile: 'papers',
                    program:
                        'https://dxp-au-search.funnelback.squiz.cloud/s/suggest.json',
                    name: 'Course Papers',
                    show: 5,
                    template: {
                        header: '<h5 class="tt-category">Course Papers</h5>',
                        suggestion: (data) => {
                            const paperCode =
                                data.label.listMetadata.paperCode[0];
                            const title =
                                data.label.listMetadata.paperYearTitle[0];
                            const url = data.label.liveUrl;
                            const queryUrl = `${baseFBUrl}?query=${title}&collection=${collection}&${papersFacet}&profile=${profile}`;

                            return `<div><a href="${
                                url || queryUrl
                            }">${paperCode} ${title}</a></div>`;
                        },
                        notFound:
                            '<div class="empty-message"><small><em>No suggestions match the current query</em></small></div>',
                        footer: `<div class="more-results">
                                    <a href="${baseFBUrl}?query={{query}}*&collection=${collection}&${papersFacet}&profile=${profile}" class="study-search__all-results">Search all papers<i class="fas fa-chevron-right" aria-hidden="true"></i></a>
                                 <div>`,
                    },
                },
            },
            length: 2,
            remote: {},
        });

        // Hook into typeahead events below and bind to checkState for different events,
        // which updates the display by adding/removing classes where needed
        $(studySearch).bind('typeahead:open', () => {
            checkState();
        });

        $(studySearch).bind('typeahead:close', () => {
            checkState();
        });

        $(studySearch).bind('typeahead:render', () => {
            checkState();
        });

        $(studySearch).bind('typeahead:change', () => {
            checkState();
        });

        $(studySearch).bind('typeahead:idle', () => {
            checkState();
        });

        $(studySearch).bind(
            'typeahead:beforeselect',
            function (event, datum, name) {
                event.preventDefault();
            }
        );
    }
}

_studySearch();
